module.exports = __webpack_public_path__ + "static/img/79053C_1_2_3_R_20190831_LC.4f2b255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/79053C_1_2_3_R_20190831_LC.png
// module id = O9Zq
// module chunks = 0